import { Flex, Text } from '@raystack/apsara';
import clsx from 'clsx';

import styles from '@src/components/Custom/ModelCommonComponents/styles.module.css';

const CustomToolTipBarGraph = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const content = payload[0] || {};
    const { payload: tooltipPayload = {} } = content;
    const {
      class: ClassName = '',
      color = '',
      refArea = 0,
      compArea = 0,
      compPercentage,
      refPercentage,
      total: DiffPercentage = 0,
      differenceInKm = 0
    } = tooltipPayload;
    return (
      <Flex
        className={styles.graphTooltipWrapper}
        direction='column'
        gap='medium'
        align='start'
      >
        <Flex gap='small' align='center'>
          <div
            style={{
              width: 7,
              height: 7,
              background: color,
              borderRadius: 99999
            }}
          />
          <Text weight={500} size={2}>
            {ClassName}
          </Text>
        </Flex>
        <Flex direction='column' align='start' gap='small'>
          <Flex align='center' justify='between'>
            <Text
              className={clsx(styles.toolTipKey, styles.toolTipSecondaryText)}
              weight={400}
              size={2}
            >
              In Reference Asset
            </Text>
            <Text weight={400} size={2} className={styles.toolTipSecondaryText}>
              : {refPercentage}% ({refArea}km<sup>2</sup>)
            </Text>
          </Flex>
          <Flex align='center' justify='between'>
            <Text
              className={clsx(styles.toolTipKey, styles.toolTipSecondaryText)}
              weight={400}
              size={2}
            >
              In Comparison Asset
            </Text>
            <Text weight={400} size={2} className={styles.toolTipSecondaryText}>
              : {compPercentage}% ({compArea}km<sup>2</sup>)
            </Text>
          </Flex>
          <Flex align='center' justify='between' weight={400} size={2}>
            <Text className={styles.toolTipKey}>Change</Text>
            <Text weight={400} size={2}>
              : {DiffPercentage}% ({differenceInKm}km<sup>2</sup>)
            </Text>
          </Flex>
        </Flex>
      </Flex>
    );
  }
};

export default CustomToolTipBarGraph;
